import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import StockItemLoader from './_load/StockItemLoader'
import EditStockForm from './EditStockForm'

const EditStockItemModal = props => {
  return (
    <ControlledModal width="52rem" disableClickOutside {...props}>
      <PermissionChecker any={['createStocks', 'editStocks']}>
        <ModalHeader />
        <StockItemLoader>
          <EditStockForm />
        </StockItemLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditStockItemModal
